// extracted by mini-css-extract-plugin
export default {"disable-menu-hover":"Filter_disable-menu-hover__sTtDb","clear-icon":"Filter_clear-icon__ukQbJ"};